import { render } from "./EventBoardReadArticles.vue?vue&type=template&id=29d22fd4"
import script from "./EventBoardReadArticles.vue?vue&type=script&lang=js"
export * from "./EventBoardReadArticles.vue?vue&type=script&lang=js"

import "./EventBoardReadArticles.vue?vue&type=style&index=0&id=29d22fd4&lang=css"

import exportComponent from "D:\\childu_lms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__